const UI_FONT_FALLBACK = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Yu Gothic UI", "Yu Gothic", "Meiryo", sans-serif';
const STORY_FONT_FALLBACK = '"Yu Mincho", "YuMincho", "Hiragino Mincho ProN", serif';

interface FontRole {
  family: string;
  fallback: string;
  variable: string;
  weights: string[];
}

const uiFont: FontRole = {
  family: "Noto Sans JP Local",
  fallback: UI_FONT_FALLBACK,
  variable: "--font-ui",
  weights: ["400", "700"],
};

const displayFont: FontRole = {
  family: "M PLUS 1p Local",
  fallback: UI_FONT_FALLBACK,
  variable: "--font-display",
  weights: ["700"],
};

const storyFont: FontRole = {
  family: "Noto Serif JP Local",
  fallback: STORY_FONT_FALLBACK,
  variable: "--font-story",
  weights: ["400"],
};

/** Loads optional local Japanese fonts without participating in critical boot. */
export class ProgressiveFontLoader {
  private started = false;

  startAfterInteractive(): void {
    if (this.started) return;
    this.started = true;
    void this.loadRole(uiFont).finally(() => this.scheduleIdleFonts());
  }

  private async loadRole(role: FontRole): Promise<void> {
    const fontSet = document.fonts;
    if (!fontSet?.load) return;

    const results = await Promise.allSettled(
      role.weights.map((weight) => fontSet.load(`${weight} 1em "${role.family}"`)),
    );
    if (results.every((result) => result.status === "fulfilled")) {
      document.documentElement.style.setProperty(role.variable, `"${role.family}", ${role.fallback}`);
    }
  }

  private scheduleIdleFonts(): void {
    const load = () => {
      void Promise.allSettled([this.loadRole(displayFont), this.loadRole(storyFont)]);
    };
    const idle = (window as Window & { requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number }).requestIdleCallback;
    if (idle) idle(load, { timeout: 1800 });
    else window.setTimeout(load, 180);
  }
}
